<template>
  <div class="font-opensans">

    <!-- ── Barra superior ── -->
    <div class="top-navbar">
      <div class="navbar-left">
        <button class="hamburger-btn" v-b-toggle.sidebar-no-header aria-label="Abrir menú">
          <b-icon icon="list" font-scale="1.5"></b-icon>
        </button>
      </div>
      <div class="navbar-center">
        <img :src="require('@/assets/nombre_alianza.png')" alt="LOGIC" class="navbar-brand-name">
      </div>
      <div class="navbar-right">
        <img :src="require('@/assets/logo_only.png')" alt="logo" class="navbar-brand-icon">
      </div>
    </div>

    <!-- ── Panel lateral ── -->
    <b-sidebar id="sidebar-no-header" aria-labelledby="sidebar-no-header-title"
               backdrop-variant="dark" backdrop shadow no-header>
      <template #default="{ hide }">
        <div class="sidebar-inner">

          <!-- Encabezado del panel -->
          <div class="sidebar-header">
            <img :src="require('@/assets/logo-alianza.png')" alt="LOGIC" class="sidebar-logo">
            <button class="sidebar-close-btn" @click="hide" aria-label="Cerrar">
              <b-icon icon="x-lg"></b-icon>
            </button>
          </div>

          <!-- Usuario activo -->
          <div class="user-badge">
            <b-icon icon="person-circle" class="user-icon"></b-icon>
            <span class="user-name">{{ operador.nombre }}</span>
          </div>

          <div class="sidebar-divider"></div>

          <!-- Navegación -->
          <nav class="sidebar-nav">
            <b-nav vertical>

              <b-nav-item class="nav-item-custom" :disabled="desactivar_sol"
                          @click="{enviarRuta('vsolicitudes','Solicitudes'),hide()}">
                <b-icon icon="card-checklist" class="nav-icon"></b-icon>
                <span>Solicitudes</span>
              </b-nav-item>

              <b-nav-item class="nav-item-custom" :disabled="desactivar_ped"
                          @click="{enviarRuta('vpedidos','Pedidos'),hide()}">
                <b-icon icon="file-earmark-ppt" class="nav-icon"></b-icon>
                <span>Pedidos</span>
              </b-nav-item>

              <b-nav-item class="nav-item-custom" :disabled="desactivar_rem"
                          @click="{enviarRuta('vremisiones','Remisiones'),hide()}">
                <b-icon icon="bootstrap-reboot" class="nav-icon"></b-icon>
                <span>Remisiones</span>
              </b-nav-item>

              <b-nav-item class="nav-item-custom nav-item-toggle" v-b-toggle.collapse-catalogos>
                <b-icon icon="ui-checks" class="nav-icon"></b-icon>
                <span>Catálogos</span>
                <b-icon icon="chevron-down" class="chevron-icon"></b-icon>
              </b-nav-item>

              <b-collapse id="collapse-catalogos">
                <b-nav vertical class="submenu">
                  <b-nav-item class="nav-item-custom nav-item-sub" :disabled="desactivar_cat"
                              @click="{enviarRuta('voperadores','vOperadores'),hide()}">
                    <b-icon icon="people" class="nav-icon"></b-icon>
                    <span>Operadores</span>
                  </b-nav-item>
                  <b-nav-item class="nav-item-custom nav-item-sub" :disabled="desactivar_cat"
                              @click="{enviarRuta('vproductos','vProductos'),hide()}">
                    <b-icon icon="bag-check" class="nav-icon"></b-icon>
                    <span>Productos</span>
                  </b-nav-item>
                  <b-nav-item class="nav-item-custom nav-item-sub" :disabled="desactivar_cat"
                              @click="{enviarRuta('vtipos_productos','vTipos_productos'),hide()}">
                    <b-icon icon="tags" class="nav-icon"></b-icon>
                    <span>Tipos de producto</span>
                  </b-nav-item>
                  <b-nav-item class="nav-item-custom nav-item-sub" :disabled="desactivar_cat"
                              @click="{enviarRuta('vsuministros','vSuministros'),hide()}">
                    <b-icon icon="box-seam" class="nav-icon"></b-icon>
                    <span>Suministros</span>
                  </b-nav-item>
                </b-nav>
              </b-collapse>

            </b-nav>
          </nav>

          <!-- Pie del panel -->
          <div class="sidebar-footer">
            <div class="sidebar-divider"></div>
            <b-nav vertical>
              <b-nav-item class="nav-item-custom nav-item-logout" @click="logout()">
                <b-icon icon="door-open" class="nav-icon"></b-icon>
                <span>Cerrar Sesión</span>
              </b-nav-item>
            </b-nav>
            <div class="version-label">
              <span>Versión {{ app.version }}</span>
            </div>
          </div>

        </div>
      </template>
    </b-sidebar>

  </div>
</template>

<script>
import * as utils from "@/shared/util";
import { mapActions, mapState } from 'vuex'
export default {
  data() {
    return {
      menuitems: {}
    }
  },
  computed: {
    ...mapState(['operador', 'app']),
    menu() {
      return this.$store.getters.getMenu;
    },
    desactivar_cat() {
      return ['Vendedor', 'Operador', 'Dosificador'].includes(this.operador.perfil);
    },
    desactivar_sol() {
      return ['Operador', 'Dosificador'].includes(this.operador.perfil);
    },
    desactivar_ped() {
      return ['Operador', 'Vendedor'].includes(this.operador.perfil);
    },
    desactivar_rem() {
      return ['Operador', 'Dosificador'].includes(this.operador.perfil);
    }
  },
  methods: {
    ...mapActions(['actupdateOperador', 'actcloseSesion', 'actnotifications']),
    enviarRuta(rout, titulo) {
      let obj = { ruta: rout, tittle: titulo }
      console.info("enviando ruta: " + JSON.stringify(obj))
      this.$store.dispatch('actupdateMenu', obj)
      if (this.$route.name !== rout) {
        this.$router.push({ name: rout });
      }
    },
    logout() {
      if (confirm("¿Salir y cerrar sesion?") == true) {
        this.actcloseSesion()
      }
    },
    tienepermiso(permiso) {
      return utils.permisoscontroles(permiso)
    }
  }
}
</script>

<style src="@/assets/css/app.css"></style>

<style scoped>
/* ── Barra superior ── */
.top-navbar {
  display: flex;
  align-items: center;
  height: 54px;
  background: linear-gradient(90deg, #0d2b5e 0%, #1a4d8f 60%, #316ea0 100%);
  padding: 0 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.navbar-left  { flex: 0 0 48px; }
.navbar-center { flex: 1; display: flex; justify-content: center; }
.navbar-right  { flex: 0 0 48px; display: flex; justify-content: flex-end; align-items: center; }

.hamburger-btn {
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 6px;
  transition: background 0.2s;
  display: flex;
  align-items: center;
}
.hamburger-btn:hover { background: rgba(255,255,255,0.15); }

.navbar-brand-name {
  height: 34px;
  filter: brightness(0) invert(1);
}

.navbar-brand-icon {
  height: 34px;
  filter: brightness(0) invert(1);
}

/* ── Interior del panel lateral ── */
.sidebar-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(180deg, #0d2b5e 0%, #1a4d8f 100%);
}

/* Encabezado */
.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px;
}

.sidebar-logo {
  width: 160px;
  filter: brightness(0) invert(1);
}

.sidebar-close-btn {
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.2);
  color: #ffffff;
  border-radius: 8px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
  display: flex;
  align-items: center;
}
.sidebar-close-btn:hover { background: rgba(255,255,255,0.25); }

/* Usuario */
.user-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px 14px;
}

.user-icon {
  font-size: 22px;
  color: #8db03c;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #8db03c;
  letter-spacing: 0.3px;
}

/* Divisor */
.sidebar-divider {
  height: 1px;
  background: rgba(255,255,255,0.12);
  margin: 0 16px;
}

/* Navegación */
.sidebar-nav {
  flex: 1;
  padding: 8px 0;
  overflow-y: auto;
}

/* ── Ítems de nav (accedidos via ::v-deep desde el padre) ── */
::v-deep .nav-item-custom .nav-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 20px;
  color: rgba(255,255,255,0.85) !important;
  font-size: 15px;
  font-weight: 500;
  border-left: 3px solid transparent;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
  text-decoration: none;
}

::v-deep .nav-item-custom .nav-link:hover {
  background: rgba(255,255,255,0.08);
  border-left-color: #8db03c;
  color: #ffffff !important;
}

::v-deep .nav-item-custom.disabled .nav-link {
  opacity: 0.35;
  pointer-events: none;
}

/* Ícono de cada ítem */
::v-deep .nav-item-custom .nav-icon {
  color: #8db03c;
  font-size: 16px;
  flex-shrink: 0;
}

/* Ítem con chevron (Catálogos) */
::v-deep .nav-item-toggle .nav-link {
  cursor: pointer;
}

.chevron-icon {
  margin-left: auto;
  font-size: 11px;
  color: rgba(255,255,255,0.5);
  transition: transform 0.25s;
}

/* Sub-ítems */
.submenu {
  background: rgba(0,0,0,0.15);
}

::v-deep .nav-item-sub .nav-link {
  padding-left: 44px !important;
  font-size: 14px !important;
}

/* Ítem de logout */
::v-deep .nav-item-logout .nav-link {
  color: rgba(255,120,120,0.85) !important;
}
::v-deep .nav-item-logout .nav-link:hover {
  color: #ff8080 !important;
  border-left-color: #ff8080;
}
::v-deep .nav-item-logout .nav-icon {
  color: rgba(255,120,120,0.85);
}

/* Pie del panel */
.sidebar-footer {
  padding-bottom: 16px;
}

.version-label {
  padding: 10px 20px 0;
  font-size: 10px;
  color: rgba(255,255,255,0.35);
  text-align: left;
}

/* ── Estilo del b-sidebar (contenedor externo) ── */
::v-deep .b-sidebar {
  width: 280px !important;
  background: transparent !important;
}

::v-deep .b-sidebar > .b-sidebar-body {
  padding: 0 !important;
  background: linear-gradient(180deg, #0d2b5e 0%, #1a4d8f 100%) !important;
}
</style>